export default __webpack_public_path__ + "static/media/SELLOS_11.4a622fb4.png";